import { render, staticRenderFns } from "./NewFormDrawer.vue?vue&type=template&id=162a07bf&scoped=true"
import script from "./NewFormDrawer.vue?vue&type=script&lang=js"
export * from "./NewFormDrawer.vue?vue&type=script&lang=js"
import style0 from "./NewFormDrawer.vue?vue&type=style&index=0&id=162a07bf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162a07bf",
  null
  
)

export default component.exports